"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SymbolDataProvider = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const constants_1 = require("./constants");
const FutureSymbolProvider_1 = require("./futures/FutureSymbolProvider");
const SpotSymbolProvider_1 = require("./spot/SpotSymbolProvider");
class SymbolDataShared {
    constructor() {
        this.subject = new rxjs_1.BehaviorSubject(constants_1.EmptyExchangeSymbolData);
        // 现货symbol实例
        this.spot = new SpotSymbolProvider_1.SpotSymbolProvider("key_exchange_symbol_cache_pionex.v2.update");
        // 合约symbol实例
        this.future = new FutureSymbolProvider_1.FutureSymbolProvider("key_future_symbol_cache_pionex.v2");
    }
    getCachedSymbolData() {
        return this.subject.getValue();
    }
    _init() {
        (0, rxjs_1.forkJoin)([this.spot.init(), this.future.init()])
            .pipe((0, operators_1.map)((data) => this.toExchangeSymbolData(data)))
            .subscribe({
            next: (data) => {
                SymbolDataProvider.shared.subject.next(data);
                this._start();
            },
            error: (error) => {
                console.log(`SymbolDataProvider: error --- ${error}`);
            },
        });
    }
    _start() {
        var _a;
        const sp = this.spot.register();
        const fp = this.future.register();
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        this.sub = (0, rxjs_1.combineLatest)([sp, fp])
            .pipe((0, operators_1.tap)((res) => {
            const data = this.toExchangeSymbolData(res);
            this.subject.next(data);
        }))
            .subscribe({
            next: () => { },
            error: (error) => {
                console.log(`SymbolDataProvider ---> ${error}`);
            },
        });
    }
    _stop() {
        var _a;
        (_a = this.sub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    }
    getSymbol(symbol) {
        return this.getCachedSymbolData().symbolMap.get(symbol);
    }
    // 把现货和合约的币对信息整合
    toExchangeSymbolData(symbolItems) {
        const initData = Object.assign({}, constants_1.EmptyExchangeSymbolData);
        symbolItems.forEach((e) => {
            if (!e) {
                return;
            }
            initData.allSymbols = initData.allSymbols.concat(e.symbols);
            initData.symbolMap = new Map([...initData.symbolMap.entries(), ...e.map.entries()]);
            if (e.symbolType === trade_utils_lib_1.ExchangeSymbolType.spot) {
                initData.spotSymbolData = e;
            }
            if (e.symbolType === trade_utils_lib_1.ExchangeSymbolType.future_perpetual) {
                initData.futurePSymbolData = e;
            }
        });
        return initData;
    }
    getAllSymbols() {
        return this.getCachedSymbolData().allSymbols;
    }
    getSymbolDataObservable() {
        return (0, rxjs_1.from)(this.subject);
    }
    getSymbolData() {
        return this.subject.getValue();
    }
}
class SymbolDataProvider {
    static init() {
        this.shared._init();
    }
    static start() {
        this.shared._start();
    }
    static stop() {
        this.shared._stop();
    }
    static getSymbol(symbol) {
        return this.shared.getSymbol(symbol);
    }
    // 手动刷新spot缓存
    static updateSpotSymbols() {
        return this.shared.spot.updateAndCache().pipe((0, operators_1.tap)((sp) => {
            if (!sp) {
                return;
            }
            const data = this.shared.toExchangeSymbolData([sp]);
            this.shared.subject.next(data);
        }));
    }
    /**
     * 返回所有 symbols
     * @param coin 可选参数，若穿，则找出该 coin 所有币对
     * @returns
     */
    static getSymbols(coin) {
        const allSymbols = this.shared.getAllSymbols();
        return coin ? allSymbols === null || allSymbols === void 0 ? void 0 : allSymbols.filter((item) => item.base.toUpperCase() === coin.toUpperCase()) : allSymbols;
    }
    static getSymbolDataObservable() {
        return this.shared.getSymbolDataObservable();
    }
    static getSymbolData() {
        return this.shared.getSymbolData();
    }
    static getSymbolCoin(coin) {
        const allSymbols = this.shared.getAllSymbols();
        return allSymbols === null || allSymbols === void 0 ? void 0 : allSymbols.find((symbol) => symbol.base === coin);
    }
}
exports.SymbolDataProvider = SymbolDataProvider;
// 构造实例，供内外部使用
SymbolDataProvider.shared = new SymbolDataShared();
